module.exports = __webpack_public_path__ + "static/media/account.dd359c3b.svg";